export default __webpack_public_path__ + "static/media/img11.36e3fa93.jpg";